import { DataBean } from "../DataBean";

export class FireEcmDocument extends DataBean {


    public async fireEcmDocumentForFlowControl(idSignAndApprovalPanel: any,idProcess:any,processDate:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_fireEcmDocumentForFlowControl_Number_Number_java.util.Date_Number", [idSignAndApprovalPanel,idProcess,processDate,idEmployee]);
    }
}